<template>
  <div class="reset-password-container">

  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { onboardingMixin } from '@/components/onboarding/form/mixin.js'

export default {
  mixins: [onboardingMixin],
  components: {

  },
  data () {
    return {

    }
  },
  computed: {
    isNestle () {
      return this.$parent.isNestle
    },
    resetCode () {
      return this.$route.query.reset_code
    }
  },
  created () {
    this.checkResetCode()
  },
  methods: {
    ...mapActions('onboarding', ['resetOnboardingPassword']),
    async checkResetCode () {
      if (!this.resetCode) {
        this.$route.replace(`/onboarding/${this.invitationId}/login`)
      }
      this.$eventBus.$emit('showLoading', true)
      try {
        const resp = await this.resetOnboardingPassword({
          invitationId: this.invitationId,
          resetCode: this.resetCode
        })
        if (resp) {
          const loginCode = resp.login_code
          this.$router.replace(`/onboarding/${this.invitationId}/create-password?loginCode=${loginCode}`)
        }
      } catch {
        this.$router.replace(`/onboarding/${this.invitationId}/login`)
      } finally {
        this.$eventBus.$emit('showLoading', false)
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
